module.exports = __webpack_public_path__ + "img/decoration-basic-mini.aed42ded.svg";